<script setup lang="ts">
import ToastViewport from '@fondof-ui/components/toast/ToastViewport.vue'
import {
  type Toast,
  type ToastContext,
  useToastsStore,
} from '@global-store/stores/toast'
import { ToastProvider } from 'radix-vue'

const toastsStore = useToastsStore()

const onToggleToast = (toast: Toast) => (open: boolean) =>
  !open && toastsStore.removeToast(toast)

const onContextUpdate = (toast: Toast) => (context: ToastContext) =>
  toastsStore.updateToast({
    ...toast,
    context,
  })
</script>

<template>
  <ToastProvider>
    <template
      v-for="toast in toastsStore.displayToasts"
      :key="toast.id"
    >
      <slot
        :name="toast.type"
        :toggle-toast="onToggleToast(toast)"
        :update-context="onContextUpdate(toast)"
        :toast="toast"
      >
        {{ toast.content }}
      </slot>
    </template>

    <ToastViewport :position="toastsStore.displayToasts[0]?.options.position" />
  </ToastProvider>
</template>
